import { render, staticRenderFns } from "./ActionMenu.vue?vue&type=template&id=cd64941c"
import script from "./action-menu.ts?vue&type=script&lang=ts&external"
export * from "./action-menu.ts?vue&type=script&lang=ts&external"
import style0 from "./action-menu.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports